module.exports = __webpack_public_path__ + "e14c89912a214abbdfa2489b641221a6.svg";